import { render, staticRenderFns } from "./MemberChangePlatformModal.vue?vue&type=template&id=f807897e&scoped=true&"
import script from "./MemberChangePlatformModal.vue?vue&type=script&lang=js&"
export * from "./MemberChangePlatformModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberChangePlatformModal.vue?vue&type=style&index=0&id=f807897e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f807897e",
  null
  
)

export default component.exports